export const FETCH_THREADS_REQUEST = 'FETCH_THREADS_REQUEST';
export const FETCH_THREADS_SUCCESS = 'FETCH_THREADS_SUCCESS';
export const FETCH_THREADS_FAIL = 'FETCH_THREADS_FAIL';

export const FETCH_THREAD_REQUEST = 'FETCH_THREAD_REQUEST';
export const FETCH_THREAD_SUCCESS = 'FETCH_THREAD_SUCCESS';
export const FETCH_THREAD_FAIL = 'FETCH_THREAD_FAIL';

export const CREATE_THREAD_REQUEST = 'CREATE_THREAD_REQUEST';
export const CREATE_THREAD_SUCCESS = 'CREATE_THREAD_SUCCESS';
export const CREATE_THREAD_FAIL = 'CREATE_THREAD_FAIL';

export const SEND_NEW_PROMPT_REQUEST = 'SEND_NEW_PROMPT_REQUEST';
export const SEND_NEW_PROMPT_SUCCESS = 'SEND_NEW_PROMPT_SUCCESS';
export const SEND_NEW_PROMPT_FAIL = 'SEND_NEW_PROMPT_FAIL';

export const START_NEW_THREAD = 'START_NEW_THREAD';

export const RENAME_THREAD_REQUEST = 'RENAME_THREAD_REQUEST';
export const RENAME_THREAD_SUCCESS = 'RENAME_THREAD_SUCCESS';
export const RENAME_THREAD_FAIL = 'RENAME_THREAD_FAIL';

export const DELETE_THREAD_REQUEST = 'DELETE_THREAD_REQUEST';
export const DELETE_THREAD_SUCCESS = 'DELETE_THREAD_SUCCESS';
export const DELETE_THREAD_FAIL = 'DELETE_THREAD_FAIL';

export const SET_PAGINATION_PAGE = 'SET_PAGINATION_PAGE';

export const OPEN_SIDEBAR = 'OPEN_SIDEBAR';

//TEXT GENERATION
export const SET_TEXT = 'SET_TEXT';
export const START_TEXT_GENERATION = 'START_TEXT_GENERATION';
export const STOP_TEXT_GENERATION = 'STOP_TEXT_GENERATION';

